import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getFaqRequest = async (params = {}) => {
  const response: AxiosResponse = await apiInstance.get("/faq", {
    params: {
      ...params,
    },
  });

  return response.data;
};
